import { Injectable } from "@angular/core";
import { Store as AppStore } from "@ngrx/store";

import * as fromStore from "@store/state";
import { AppState } from "@store/state";
import {
  AuthProtocol,
  BasePostProvider,
  DataTransformationProtocol,
} from "@tendercuts/http";
import { User } from "@tendercuts/models";

import { HttpClient } from "@angular/common/http";
import { EndPoint } from "@endpoint";
import { Observable } from "rxjs";

@Injectable()
export class FlockAuthService
  extends BasePostProvider<User>
  implements AuthProtocol, DataTransformationProtocol {
  KEY: any = "user22";

  constructor(
    public http: HttpClient,
    public endpointService: EndPoint,
    public store: AppStore<AppState>,
  ) {
    super(http);
    this.delegate = this;
  }

  getToken(): Observable<User> {
    return this.store.select(fromStore.getUser);
  }

  get isAuthenticatedEndpoint(): boolean {
    return false;
  }

  get authProtocol(): any {
    return null;
  }

  get model(): typeof User {
    return User;
  }

  get endpoint(): string {
    return this.endpointService.flockAuth();
  }

  postProcessResponse(data: any): Array<any> {
    return this.data[0];
  }
}
